import { CheckOutlined } from '@ant-design/icons';
import { Line as ProgressBar } from 'rc-progress';

import Button from '~/shared/components/form-fields/button';
import { PAGE_NAMES } from '~/shared/constants';
import { getLocaleLink } from '~/shared/helpers/browser-helpers';
import { getUrl } from '~/shared/helpers/string-helpers';
import type { CourseType } from '~/shared/types/course-type';
import type { I18nextOptionsType } from '~/shared/types/i18n-type';

import '~/shared/components/items-navigator/components/course-row-item/course-row-item.scss';

import noImage from '~/assets/no-image.webp';

type CourseRowItemPropsType = {
  data: CourseType;
  t: (key: string, options: I18nextOptionsType) => string;
};

const CourseRowItem = ({ data, lng, t }: CourseRowItemPropsType) => {
  const progress = 0;

  return (
    <article itemProp="blogPosts" itemScope itemType="http://schema.org/BlogPosting" className="course-row-item">
      <link itemProp="image" href={data?.data?.image?.path ?? noImage.src} />
      <div
        className="course-row-item__image"
        style={{
          background: `url(${data?.data?.image?.path ?? noImage.src}) center/cover no-repeat`,
        }}
      />
      <div className="course-row-item__right-side">
        <h2 itemProp="headline" className="course-row-item__title">
          {data?.data?.title}
        </h2>
        <div className="course-row-item__content">
          <div className="course-row-item__progress">
            <div className="course-row-item__indicator">
              <ProgressBar percent={progress} strokeWidth={4} trailWidth={4} strokeColor="aqua" />
            </div>
            <div className="course-row-item__finished-status">
              {progress}%&nbsp;{data?.isFinishedCourse && <CheckOutlined />}
            </div>
          </div>
          <div className="course-row-item__actions">
            <Button
              type="primary"
              size="small"
              className="main-button"
              href={getLocaleLink(
                getUrl({
                  link: PAGE_NAMES.PLATFORM_VIDEO_COURSE_METRICS,
                  alias: data?.data?.alias,
                }),
                lng,
              )}
            >
              {t('button.metrics')}
            </Button>
            <Button
              type="primary"
              size="small"
              href={getLocaleLink(
                getUrl({
                  link: PAGE_NAMES.PLATFORM_VIDEO_COURSE_DASHBOARD,
                  alias: data?.data?.alias,
                }),
                lng,
              )}
            >
              {t('button.continue-course')}
            </Button>
          </div>
        </div>
      </div>
    </article>
  );
};

export default CourseRowItem;
